// extracted by mini-css-extract-plugin
module.exports = {"twitterButton":"TokenCardHeader_twitterButton__2Synz"};